const API_URL = import.meta.env.VITE_API_URL;

export const getSettings = async () => {
  try {
    const response = await fetch(`${API_URL}/api/settings`);
    if (!response.ok) throw new Error('Error fetching settings');
    const data = await response.json();
    return data.settings || data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    return null;
  }
};
